
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
    Box,
    Typography,
    Paper,
    Button,
    Grid,
    Container,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import axios from 'axios';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const CashFreePaymetSuccess = () => {
    const query = new URLSearchParams(useLocation().search);
    console.log('querysuccess', query)
    const paymentId = query.get('payment_id');
    const status = query.get('payment_status');
     const UserId = sessionStorage.getItem("UserId");
    useEffect(() => {
        const fetchData = async () => {
            console.log("payment ", paymentId);

            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL}Payment/GetPaymentDetails/${paymentId}`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJWYWxpZElzc3VlciI6IlByYXN5c3QiLCJWYWxpZEF1ZGllbmNlIjoiUHJhc3lzdCJ9.gMMGQ74cWLoymeDv0D4c3UQKTEJSCzdkXoxlW4qF5QU'
                        },
                    }
                );

                console.log("response 444", response);
                let obj = response.data;
                
                if (response.status === 200 && obj.id) {
                    if (obj.status === true) {
                        let payload = {
                            "ResidentId": 1, 
                            "MobileNo": obj.phone ? obj.phone.replace('+91', '').replace('+', '') : '', // Remove country code if present
                            "id": obj.id,
                            "title": obj.title || '',
                            "payment_type": obj.payment_type || '',
                            "payment_request": obj.payment_request || '',
                            "status": "True", 
                            "link": obj.link || "http://paymentlink.com",
                            "product": obj.product || "product_name",
                            "seller": obj.seller || '',
                            "currency": obj.currency || '',
                            "amount": obj.amount || '',
                            "name": obj.name || '',
                            "email": obj.email || '',
                            "phone": obj.phone || '',
                            "payout": obj.payout || "50.00",
                            "fees": obj.fees || "2.00",
                            "total_taxes": obj.total_taxes || "5.00",
                            "cases": Array.isArray(obj.cases) && obj.cases.length > 0 ? obj.cases.join(',') : "case_123", // Handle empty array
                            "affiliate_id": obj.affiliate_id || "affiliate_123",
                            "affiliate_commission": obj.affiliate_commission || "10.00",
                            "instrument_type": obj.instrument_type || '',
                            "billing_instrument": obj.billing_instrument || '',
                            "failure": obj.failure ? (obj.failure.message || obj.failure) : "None", // Handle null failure
                            "bank_reference_number": obj.bank_reference_number || '',
                            "created_at": obj.created_at || '',
                            "updated_at": obj.updated_at || '',
                            "completed_at": obj.completed_at || '',
                            "tax_invoice_id": obj.tax_invoice_id || '',
                            "resource_uri": obj.resource_uri || ''
                        }

                        console.log("payload payment insert", payload);
                    
                    } else {
                        console.log("Payment not successful, status:", obj.status);
                        toast.error('Payment was not successful');
                    }
                }
            } catch (error) {
                console.error('Error making payment request:', error);
                toast.error('Error fetching payment details');
            }
        }

        if (paymentId) {
            fetchData();
        }
    }, [paymentId]) 

   

    return (
        <Container maxWidth="md" sx={{ marginTop: 6 }}>
            <ToastContainer />
            <Paper elevation={3} sx={{ padding: 4, borderRadius: 2 }}>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    textAlign="center"
                >
                   
                            <CheckCircleIcon
                                sx={{
                                    fontSize: 80,
                                    color: 'green',
                                    marginBottom: 2,
                                }}
                            />
                            <Typography variant="h4" gutterBottom>
                                Payment Successful
                            </Typography>
                            <Typography variant="body1">
                                Thank you! Your payment has been processed successfully.
                            </Typography>
                            {paymentId && (
                                <Typography variant="body2" sx={{ marginTop: 2 }}>
                                    Payment ID: <strong>{paymentId}</strong>
                                </Typography>
                            )}
                        
                           
                          
                  
                    <Box sx={{ marginTop: 4 }}>
                        <Button
                            variant="contained"
                            size="large"
                            sx={{
                                backgroundColor:  'green' ,
                                color: '#fff',
                                
                            }}
                            // href="/payment"
                        >
                            { 'Go to Dashboard' }
                        </Button>
                    </Box>
                </Box>
            </Paper>
        </Container>
    );
};

export default CashFreePaymetSuccess;